import { useEffect, useState } from 'preact/hooks';
import { get } from '../../api';
import type { ContentDraft } from '../../types';
import { LcarsPanel } from '../layout/LcarsPanel';
import { LoadingSpinner } from '../shared/LoadingSpinner';

export function MissionsPanel() {
  const [drafts, setDrafts] = useState<ContentDraft[] | null>(null);

  useEffect(() => {
    get<{ drafts: ContentDraft[] }>('/api/drafts?status=Staged')
      .then((data) => setDrafts(data.drafts))
      .catch(console.error);
  }, []);

  const count = drafts ? drafts.length : 0;

  return (
    <LcarsPanel color="var(--red)" title="Missions" badge={drafts ? `${count} ACTIVE` : undefined}>
      {!drafts ? (
        <LoadingSpinner />
      ) : drafts.length === 0 ? (
        <div style={{ padding: '16px', fontFamily: 'var(--mono)', fontSize: '11px', color: 'var(--text-dim)' }}>
          No staged drafts requiring review
        </div>
      ) : (
        drafts.map((draft) => {
          const tier = count > 5 ? 'red' : count > 2 ? 'amber' : 'blue';
          return (
            <div class="mission" key={draft.id}>
              <div class={`mission-indicator ind-${tier}`}></div>
              <div class="mission-body">
                <div class={`mission-tier tier-${tier}`}>
                  {tier === 'red' ? 'Urgent' : tier === 'amber' ? 'Warning' : 'Info'}
                </div>
                <div class="mission-title">{draft.headline}</div>
                <div class="mission-desc">{draft.channel} · {draft.word_count} words</div>
              </div>
              <button class={`mission-cta${tier === 'red' ? ' primary' : ''}`}>Review</button>
            </div>
          );
        })
      )}
    </LcarsPanel>
  );
}
